import React from 'react';
import PropTypes from 'prop-types';

import { TranslationProvider } from '../../../../../ui-kitchen/src';
import useAmexAdsContainerState from './useAmexAdsContainerState';
import './AmexAdsContainer.scss';

const AmexAdsContainer = ({ page, routeKey }) => {
  const {
    containerRef,
    height,
    width,
    placementId,
    adKey,
    isVisible,
    isAdReady,
    isAdDisplaying,
    gTagLoaded,
    isAdFocused,
  } = useAmexAdsContainerState({
    page,
    routeKey,
  });

  if (!isVisible) return null;

  return (
    <div
      ref={containerRef}
      className="amex-ads-container"
      style={{ ...(!gTagLoaded && { height: 0, padding: 0 }) }}
    >
      {isAdReady && (
        <>
          <TranslationProvider translationKey="advertisement">
            <div
              className="text-align-center amex-ads-advertisement-label"
              style={{
                visibility: isAdDisplaying ? 'visible' : 'hidden',
              }}
            >
              ADVERTISEMENT
            </div>
          </TranslationProvider>
          <div
            key={adKey}
            id={placementId}
            className={isAdFocused ? 'amex-ads-slot--focused' : ''}
            data-testid="amex-ads"
            style={{ width, height }}
          />
        </>
      )}
    </div>
  );
};

AmexAdsContainer.propTypes = {
  page: PropTypes.string.isRequired,
  routeKey: PropTypes.string,
};

AmexAdsContainer.defaultProps = {
  routeKey: undefined,
};

export default AmexAdsContainer;
